/* eslint-disable no-nested-ternary */
/* eslint-disable new-cap */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table,
} from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import MOActions from '@Actions/moActions';
import { v4 as uuidv4 } from 'uuid';
import './style.scss';

/**
 *
 */
class OtherCharges extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      otherChargeColumns: [
        {
          title: 'Charge Name',
          render: (item) => `${item?.charge_name} `,
        },
        {
          title: 'Estimated Amount',
          render: (item) => this.props.MONEY(item?.est_charge_amount || '0'),
        },
        {
          title: 'Actual Amount',
          render: (item) => {
            const { extraCharges } = this.state;
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '4px' }}>
                  {this.props.MONEY(0).split(0)?.[0]}
                </div>
                <H3FormInput
                  value={item.charge_amount}
                  type="number"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(e) => {
                    const copyData = JSON.parse(JSON.stringify(extraCharges));
                    copyData.map((data) => {
                      if (item.key === data.key) {
                        // eslint-disable-next-line no-param-reassign
                        data.charge_amount = e.target.value;
                      }
                      return data;
                    });
                    this.setState({
                      extraCharges: copyData,
                    });
                  }}
                />
              </div>
            );
          },
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { selectedMO, fgTenantProductId } = this.props;
    this.setState({
      extraCharges: selectedMO?.extra_charges
        ?.filter((item) => item?.fg_tenant_product_id == fgTenantProductId)
        ?.map((charge) => ({ ...charge, key: uuidv4() })),
    });
  }

  /**
   *
   */
  updateOtherCharges = () => {
    const {
      extraCharges,
    } = this.state;
    const {
      selectedMO, updateMOOtherCharges, callback, fgTenantProductId,
    } = this.props;
    if (selectedMO) {
      const payload = {
        mo_id: selectedMO?.mo_id,
        extra_charges: [
          ...extraCharges?.map((item) => ({ ...item, charge_amount: Number(item?.charge_amount) || 0 })),
          ...selectedMO?.extra_charges?.filter((item) => item?.fg_tenant_product_id != fgTenantProductId),
        ],
      };
      updateMOOtherCharges(payload, () => callback());
    }
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      updateMOOtherChargesLoading, getMOByIdLoading, selectedMO,
    } = this.props;
    const {
      extraCharges, otherChargeColumns,
    } = this.state;

    return (
      <Fragment>
        <div className="ant-row">
          <div className="vq__wrapper other-charges_wrapper">
            <Table
              bordered
              showHeader
              size="small"
              loading={getMOByIdLoading || updateMOOtherChargesLoading}
              columns={otherChargeColumns}
              dataSource={extraCharges || []}
              pagination={false}
              scroll={{ x: true }}
            />
            <div className="custom-drawer__footer">
              <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
                <H3Button
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  text="Create"
                  onClick={() => this.updateOtherCharges()}
                  isLoading={updateMOOtherChargesLoading}
                  disabled={updateMOOtherChargesLoading}
                  style={{
                    width: '180px',
                    borderRadius: '5px',
                    padding: '7px 0px',
                    marginLeft: '0',
                  }}
                />
              </div>
            </div>
            {/* )} */}
          </div>

          <div className="custom-drawer__footer">
            <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text="Update"
                onClick={() => this.updateOtherCharges()}
                isLoading={updateMOOtherChargesLoading}
                disabled={updateMOOtherChargesLoading}
                style={{
                  width: '180px',
                  borderRadius: '5px',
                  padding: '7px 0px',
                  marginLeft: '0',
                }}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, MOReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateMOOtherChargesLoading: MOReducers.updateMOOtherChargesLoading,
  selectedMO: MOReducers.selectedMO,
  getMOByIdLoading: MOReducers.getMOByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateMOOtherCharges: (payload, callback) => dispatch(MOActions.updateMOOtherCharges(payload, callback)),
});

OtherCharges.propTypes = {
  getMOByIdLoading: PropTypes.bool,
  selectedMO: PropTypes.any,
  updateMOOtherCharges: PropTypes.func,
  updateMOOtherChargesLoading: PropTypes.bool,
  callback: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OtherCharges));
